import axiosRequest from "@/api/axios-optimize"

// 获取登录日志
export function getLoginLogList(
  data = {},
  config = {
    noShowLoading: true, // 配置不展示加载动画
    preventDuplicateRequestsType: "cancel" // 配置重复请求时 取消前面的请求
  }
) {
  return axiosRequest.get(`/xiaobuAdmin/log/getLoginLogList`, { params: data, ...config })
}

// 获取操作日志
export function getOperateLogList(
  data = {},
  config = {
    noShowLoading: true, // 配置不展示加载动画
    preventDuplicateRequestsType: "cancel" // 配置重复请求时 取消前面的请求
  }
) {
  return axiosRequest.get(`/xiaobuAdmin/log/getOperateLogList`, { params: data, ...config })
}

// 获取定时器任务日志
export function getScheduleLogList(
  data = {},
  config = {
    noShowLoading: true, // 配置不展示加载动画
    preventDuplicateRequestsType: "cancel" // 配置重复请求时 取消前面的请求
  }
) {
  return axiosRequest.get(`/xiaobuAdmin/log/getScheduleLogList`, { params: data, ...config })
}

// 获取操作日志详情
export function getOperateLogDetailById(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.get(`/xiaobuAdmin/log/getOperateLogDetail/${data.id}`, { params: {}, ...config})
}

// 获取登录日志详情
export function getLoginLogDetailById(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.get(`/xiaobuAdmin/log/getLoginLogDetail/${data.id}`, { params: {}, ...config})
}

// 获取登录日志详情
export function getScheduleLogDetailById(data = {}, config = {
  preventDuplicateRequestsType: "prevent"
}) {
  return axiosRequest.get(`/xiaobuAdmin/log/getScheduleLogDetail/${data.id}`, { params: {}, ...config})
}

// 删除登录日志
export function batchDeleteLoginLog(data = {}, config = {
  preventDuplicateRequestsType: "prevent" // 配置重复请求时 取消前面的请求
}) {
  return axiosRequest.delete(`/xiaobuAdmin/log/batchDeleteLoginLog`, { data, ...config })
}

// 删除全部登录日志
export function deleteAllLoginLog(data = {}, config = {
  preventDuplicateRequestsType: "prevent" // 配置重复请求时 取消前面的请求
}) {
  return axiosRequest.delete(`/xiaobuAdmin/log/deleteAllLoginLog`, { data, ...config })
}

// 删除操作日志
export function batchDeleteOperateLog(data = {}, config = {
  preventDuplicateRequestsType: "prevent" // 配置重复请求时 取消前面的请求
}) {
  return axiosRequest.delete(`/xiaobuAdmin/log/batchDeleteOperateLog`, { data, ...config })
}

// 删除全部登录日志
export function deleteAllOperateLog(data = {}, config = {
  preventDuplicateRequestsType: "prevent" // 配置重复请求时 取消前面的请求
}) {
  return axiosRequest.delete(`/xiaobuAdmin/log/deleteAllOperateLog`, { data, ...config })
}

// 删除操作日志
export function batchDeleteScheduleLog(data = {}, config = {
  preventDuplicateRequestsType: "prevent" // 配置重复请求时 取消前面的请求
}) {
  return axiosRequest.delete(`/xiaobuAdmin/log/batchDeleteScheduleLog`, { data, ...config })
}

// 删除全部登录日志
export function deleteAllScheduleLog(data = {}, config = {
  preventDuplicateRequestsType: "prevent" // 配置重复请求时 取消前面的请求
}) {
  return axiosRequest.delete(`/xiaobuAdmin/log/deleteAllScheduleLog`, { data, ...config })
}